import { useAppSelector } from "redux/hooks";

const useMerchant = (): boolean => {
  const { userOtp } = useAppSelector((state) => state.otp);
  const isNextScreensB = userOtp?.NextScreens?.includes("B") as boolean;
  const isMerchant: boolean = isNextScreensB;

  return isMerchant;
};

export default useMerchant;
